// extracted by mini-css-extract-plugin
export default {"container":"styles_container__a8jq-","icon":"styles_icon__loSjV","bodyText":"styles_bodyText__P8ZKT","header":"styles_header__etp87","button":"styles_button__tOt68"};